import React from "react";
import Owner from "../../assets/Owner.png";
import Image1 from "../../assets/WhoIsMemboticfor/Image1.png";
import Image2 from "../../assets/WhoIsMemboticfor/Image2.png";
import Image3 from "../../assets/WhoIsMemboticfor/Image3.png";
import Image4 from "../../assets/WhoIsMemboticfor/Image4.png";
export default function WhoIsMemboticFor() {
  return (
    <div>
      <div className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Image1}
                alt="Fitness club using Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Fitness Clubs</h2>
              <p>
                Membotic is the all-in-one platform that helps fitness clubs
                streamline operations and grow their community.
              </p>
              <p>
                Easily manage member sign-ups, automate payments for classes and
                subscriptions, and keep track of attendance without the admin
                hassle.
              </p>
              <p>
                Offer pay-as-you-go or recurring memberships, promote your club
                online, and give your members a smooth booking experience.
              </p>
              <p>
                <strong>More time coaching, less time coordinating.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="py-5 bg-light">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Side: Image */}
      <div className="col-md-6 text-center mb-4 mb-md-0">
        <img
          src={Image2}
          alt="Dance school using Membotic"
          className="img-fluid rounded"
        />
      </div>

      {/* Right Side: Text */}
      <div className="col-md-6">
        <h2>Dance Schools</h2>
        <p>
          Membotic makes running your dance school smoother — from class scheduling to payments and everything in between.
        </p>
        <p>
          Manage students across multiple classes, track attendance, and offer both drop-in and subscription-based lessons with ease.
        </p>
        <p>
          Let parents and dancers book online, stay informed, and stay connected — all from one simple platform.
        </p>
        <p>
          <strong>Focus on the dancing — we'll handle the rest.</strong>
        </p>
      </div>
    </div>
  </div>
</div>

<div className="py-5 bg-white">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Side: Image */}
      <div className="col-md-6 text-center mb-4 mb-md-0">
        <img
          src={Image3}
          alt="Martial arts academy using Membotic"
          className="img-fluid rounded"
        />
      </div>

      {/* Right Side: Text */}
      <div className="col-md-6">
        <h2>Martial Arts Academies</h2>
        <p>
          Membotic helps martial arts academies stay organised and grow with tools built for instructors and students alike.
        </p>
        <p>
          Schedule classes, manage students by belt level or program, and automate payments for memberships or one-off sessions.
        </p>
        <p>
          Track attendance, simplify communication, and let students or parents book online — all in one place.
        </p>
        <p>
          <strong>Train harder. We'll handle the admin.</strong>
        </p>
      </div>
    </div>
  </div>
</div>
<div className="py-5 bg-light">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Side: Image */}
      <div className="col-md-6 text-center mb-4 mb-md-0">
        <img
          src={Image4}
          alt="Yoga and Pilates studio using Membotic"
          className="img-fluid rounded"
        />
      </div>

      {/* Right Side: Text */}
      <div className="col-md-6">
        <h2>Yoga & Pilates Studios</h2>
        <p>
          Membotic gives yoga and Pilates studios a calm and efficient way to manage bookings, payments, and communication.
        </p>
        <p>
          Offer flexible class schedules, take drop-ins or subscriptions, and keep track of attendance with ease.
        </p>
        <p>
          Let your clients book sessions online, stay informed, and enjoy a smooth experience from mat to message.
        </p>
        <p>
          <strong>Stay present in your practice — we’ll handle the rest.</strong>
        </p>
      </div>
    </div>
  </div>
</div>
<div className="py-5 bg-white">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-md-8 text-center">
        <h2>Is Membotic Right for You?</h2>
        <p>
          If you run a facility where people pay to attend classes, sessions, or activities — whether it's fitness, dance, martial arts, or something else — Membotic is built for you.
        </p>
        <p>
          Still unsure? Reach out any time at <strong>info@membotic.com</strong>.
        </p>
      </div>
    </div>
  </div>
</div>

    </div>
  );
}
